import React from "react";
import { useNavigate } from "react-router-dom";
import "./ErrorBoundary.css";

export default function ErrorBoundary({ code = "GENERIC" }) {
  const navigate = useNavigate();

  // Define messages for error codes
  const errorMessages = {
    FORM_INVALID_ID: {
      title: "Invalid Access",
      message: "No participant ID was provided. Please try again.",
    },
    FORM_NOT_FOUND: {
      title: "Participant Not Found",
      message: "Something went wrong. Please contact support.",
    },
    ASSESSMENT_INVALID_ID: {
      title: "Invalid Access",
      message: "No Score ID was provided. Please try again.",
    },
    ASSESSMENT_NOT_FOUND: {
      title: "Assessment Not Found",
      message: "Something went wrong. Please contact support.",
    },
    SERVER_ERROR: {
      title: "Server Error",
      message: "Something went wrong on our side. Please try again later or contact support.",
    },
    GENERIC: {
      title: "An Error Occurred",
      message: "An unexpected error has happened. Please try again.",
    },
  };

  const { title, message } = errorMessages[code] || errorMessages.GENERIC;

  return (
    <div className="error-container">
      <img src="/app/Image/MainLogo.png" alt="Logo" className="error-logo" />
      <div className="error-card">
        <div className="error-icon">⚠️</div>
        <h2>{title}</h2>
        <p>{message}</p>
        <button className="error-btn" onClick={() => (window.location.href = "https://www.revolvingchange.com")}>
          Go Home
        </button>
      </div>
    </div>
  );
}
